<template>
    <div class="flex flex-grow justify-between items-stretch rounded-t bg-gray-100">
        <div
            class="flex-1 flex flex-col justify-center z-20 py-4 rounded-tl clip-path-right-point"
            :class="{
                'text-white bg-gradient-blue': $route.name == uploadRoute,
                'text-blue-500 bg-white': $route.name == matchRoute || $route.name == previewRoute,
            }"
        >
            <div class="flex items-center h-full pl-8 pr-16">
                <nio-icon class="mr-4 text-4xl" name="regular/monitor-upload" />
                <div class="flex flex-col">
                    <div class="text-xl">
                        {{ $t('imports.steps.uploadTitle') }}
                    </div>
                    <div>
                        {{ $t('imports.steps.uploadDescription') }}
                    </div>
                </div>
            </div>
        </div>

        <div
            class="flex-1 flex flex-col flex-grow z-10 h-full -ml-8 py-4 clip-path-right-point"
            :class="{
                'bg-gray-100': $route.name == uploadRoute,
                'text-white bg-gradient-blue': $route.name == matchRoute,
                'text-blue-500 bg-white': $route.name == previewRoute,
            }"
        >
            <div class="flex items-center h-full pl-16 pr-16">
                <nio-icon class="mr-4 text-4xl" name="regular/button-shuffle" />
                <div class="flex flex-col">
                    <div class="text-xl">
                        {{ $t('imports.steps.matchTitle') }}
                    </div>
                    <div>
                        {{ $t('imports.steps.matchDescription') }}
                    </div>
                </div>
            </div>
        </div>

        <div
            class="flex-1 flex flex-col flex-grow h-full -ml-8 py-4 rounded-tr"
            :class="{
                'bg-gray-100': $route.name == uploadRoute || $route.name == matchRoute,
                'text-white bg-gradient-blue': $route.name == previewRoute
            }"
        >
            <div class="flex items-center h-full pl-16 pr-8">
                <nio-icon class="mr-4 text-4xl" name="regular/task-list-check-1" />
                <div class="flex flex-col">
                    <div class="text-xl">
                        {{ $t('imports.steps.previewTitle') }}
                    </div>
                    <div>
                        {{ $t('imports.steps.previewDescription') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            pathPrefix: {
                type: String,
                required: true,
            },
        },

        computed: {
            uploadRoute() {
                return `${this.pathPrefix}.import.upload`;
            },

            matchRoute() {
                return `${this.pathPrefix}.import.match`;
            },

            previewRoute() {
                return `${this.pathPrefix}.import.preview`;
            },
        },
    };
</script>
